import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logo from './images/logo1.jpg'
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(true);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation(); // ✅ Track current route
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
        const menuCheckbox = document.getElementById("menu-btn");
        if (menuCheckbox) {
            menuCheckbox.checked = false;
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            if (scrollTop > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return (
        <div>
            <nav className="sticky-top position-fixed" >
                <div className="wrapper">
                    <div className="logo">
                        <Link to="/" onClick={closeMenu}>
                            <img src={logo} alt="Company Logo" />
                        </Link>
                    </div>
                    <input type="checkbox" name="slider" id="menu-btn" onChange={toggleMenu} />
                    <input type="checkbox" name="slider" id="close-btn" onChange={toggleMenu} />
                    <ul className="nav-links m-auto">
                        <label
                            htmlFor="close-btn"
                            className="btn close-btn" onClick={closeMenu}
                        >
                            <i className="ri-menu-3-line"></i>
                        </label>

                        <li>
                            <Link to="/" className={location.pathname === "/" ? "active" : ""} style={{ color: '#000' }} onClick={closeMenu}>Home</Link>
                        </li>
                        <li>
                            <Link to="/user-about" className={location.pathname === "/user-about" ? "active" : ""} style={{ color: '#000' }} onClick={closeMenu}>About</Link>
                        </li>
                        {/* <li>
                            <Link to="/engineering-services" style={{ color: '#000' }} onClick={closeMenu}>Engineering & services</Link>
                        </li> */}
                        <li>
                            <Link to="/trainings" className={location.pathname === "/trainings" ? "active" : ""} style={{ color: '#000' }} onClick={closeMenu}>Trainings & Courses</Link>
                        </li>
                        {/* <li className="home_service_list">
                            <a
                                href="./services.html"
                                className="desktop-item"
                                style={{ color: '#000' }}
                            >
                                Trainings &#8595;
                            </a>
                            <input type="checkbox" id="showDrop3" />
                            <label htmlFor="showDrop3" className="mobile-item" style={{ color: '#000' }}>
                            Trainings
                            </label>
                            <ul className="drop-menu">
                                <li>
                                    <a href="#">Python Programming</a>
                                </li>
                                <li>
                                    <a href="./QualityAssurance.html">Java FullStack Development</a>
                                </li>
                                <li>
                                    <a href="./App-Development.html">JavaScript and Node.js</a>
                                </li>
                                <li>
                                    <a href="./AI.html">C ++ </a>
                                </li>
                                <li>
                                    <a href="./ML.html">Amazon web series</a>
                                </li>
                                <li>
                                    <a href="./E&T.html">Engineering and Technical Services</a>
                                </li>
                                <li>
                                    <a href="./Salesforce.html">Salesforce® Implementation and Support Services</a>
                                </li>
                                <li>
                                    <a href="./IT-Infrastructure.html">IT Infrastructure</a>
                                </li>
                            </ul>
                        </li> */}
                        {/* <li>
                            <Link to="/teachers" style={{ color: '#000' }}> Teachers</Link>
                        </li> */}
                        {/* <li>
                            <Link to="/user-courses" style={{ color: '#000' }} onClick={closeMenu}></Link>
                        </li> */}
                        <li>
                            <Link to="/events" className={location.pathname === "/events" ? "active" : ""} style={{ color: '#000' }} onClick={closeMenu}>Events</Link>
                        </li>
                        <li>
                            <Link to="/user-blogs" className={location.pathname === "/user-blogs" ? "active" : ""} style={{ color: '#000' }} onClick={closeMenu}>Blogs</Link>
                        </li>
                        <li>
                            <Link to="/careers" className={location.pathname === "/careers" ? "active" : ""} style={{ color: '#000' }} onClick={closeMenu}>Careers</Link>
                        </li>
                        <li>
                            <Link to="/contact-us" className={location.pathname === "/contact-us" ? "active" : ""} style={{ color: '#000' }} onClick={closeMenu}>Contact</Link>
                        </li>
                        <li>
                            <a href="https://wa.me/+918688964015" target='_blank' className="login_mobile" style={{ color: '#000' }} onClick={closeMenu} >Login</a>
                        </li>
                    </ul>
                    <div>
                        <a href="https://wa.me/+918688964015" target='_blank' className="login_desk" onClick={closeMenu} >Login</a>
                    </div>
                    <label
                        htmlFor="menu-btn"
                        className="btn menu-btn"
                    >
                        <i className="ri-menu-3-line"></i>
                    </label>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
